import gql from 'graphql-tag';
import { GetAllTicketNumbersQuery } from '.';
import { GetTicketNumberGroupQuery } from '../../ticketNumberGroup/graphql/getTicketNumberGroupApi';

const DestroyTicketNumberMutation = gql`
  mutation DestroyTicketNumber($input: TicketNumberDestroyInput!) {
    ticket_number_destroy(input: $input) 
  }
`;

export const destroyTicketNumber = (client, ticketNumberId) => {
  const variables = {
    input: {
      id: ticketNumberId,
    },
  };

  const options = {
    mutation: DestroyTicketNumberMutation,
    variables,
    refetchQueries: [
      {
        query: GetAllTicketNumbersQuery,
      },
      {
        query: GetTicketNumberGroupQuery,
      },
    ],
  };

  return client.mutate(options);
};
